export default __webpack_public_path__ + "static/media/img-button-Business.793a0de6.svg";